<template>
  <v-layout column>
    <v-flex mb-2>
      <v-layout>
        <v-spacer grow />
        <v-flex shrink>
          <StatusSelect v-model="optionForShowCreatives" />
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex>
      <v-layout>
        <v-flex>
          <DeliveryLocationGroupTable
            v-model="currentDeliveryLocationGroup"
            :items="menuSetting.visibleDeliveryLocationGroups"
            :form="form"
          />
        </v-flex>
        <v-divider vertical />
        <v-flex>
          <CreativeTable :creatives="creatives" :active-only="activeOnly" />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import StatusSelect, {
  StatusOptions,
} from './CampaignModalPageCreativeStatusSelect'
import CreativeTable from './CampaignModalPageConfirmCreativeTable'
import DeliveryLocationGroupTable from './CampaignModalPageCreativeDeliveryLocationGroupTable'

export default {
  name: 'CampaignModalPageConfirmCreativeModeDeliveryGroup',
  components: {
    StatusSelect,
    CreativeTable,
    DeliveryLocationGroupTable,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    const [
      currentDeliveryLocationGroup,
    ] = this.form.campaign.menuSetting.deliveryLocationGroups
    return {
      currentDeliveryLocationGroup,
      optionForShowCreatives: StatusOptions.ACTIVE_ONLY,
    }
  },
  computed: {
    menuSetting() {
      return this.form.campaign.menuSetting
    },
    creativeSchedules() {
      return this.currentDeliveryLocationGroup
        ? this.currentDeliveryLocationGroup.creativeSchedules
        : []
    },
    creatives() {
      return this.currentDeliveryLocationGroup
        ? this.currentDeliveryLocationGroup.creatives
        : []
    },
    activeOnly() {
      return this.optionForShowCreatives === StatusOptions.ACTIVE_ONLY
    },
    deliveryLocationGroups() {
      return this.menuSetting.deliveryLocationGroups.map(g =>
        this.menuSetting.findLocationGroup(g.locationGroupId),
      )
    },
    currentLocationGroup: {
      get() {
        return (
          this.currentDeliveryLocationGroup &&
          this.menuSetting.findLocationGroup(
            this.currentDeliveryLocationGroup.locationGroupId,
          )
        )
      },
      set(locationGroup) {
        this.currentDeliveryLocationGroup = this.menuSetting.deliveryLocationGroups.find(
          g => g.locationGroupId === locationGroup.id,
        )
      },
    },
  },
}
</script>

<style></style>
